import * as api from '../api'
import { GET_LIVE_DETAILS, INCREMENT_LIVE_TIMER, INCREMENT_PERIOD} from '../constants/actionTypes.js'

// Action creator
export const getLiveDetails = (idLive, date = '', mode, competition) => async (dispatch) => {

    try{
        const {data} = await api.getLiveDetails(idLive, date, mode, competition)
        dispatch({ type: GET_LIVE_DETAILS, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const updateLiveDetails = () => async (dispatch, getState) => {

    try{
        const idLive = getState().live._id

        if(!idLive)
            return

        const {data} = await api.getLiveDetails(idLive)
        dispatch({ type: GET_LIVE_DETAILS, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const incrementLiveTime = () => async (dispatch, getState) => {

    try{
        let timer = getState().live.timer

        dispatch({ type: INCREMENT_LIVE_TIMER, payload: timer+1})
    } catch(error){
        console.log(error.message)
    } 
}

export const changePeriod = () => async (dispatch) => {

    try{

        dispatch({ type: INCREMENT_PERIOD })
    } catch(error){
        console.log(error.message)
    } 
}